export class EntryAdvanceSearchModel {
    constructor() {
        this.referenceNumber = "";
        this.stateLists = [];
        this.typeLists = [];
        this.categoriesLists = [];
        this.tagsLists = [];
        this.statusLists = [];
        this.referenceLink = "";
        this.updatedBy = "";
        this.updatedByValue = "";
        this.dateOpenedStartDateAsString = "";
        this.dateOpenedEndDateAsString = "";
        this.updateOnStartDateAsString = "";
        this.updateOnEndDateAsString = "";
        this.dateOpenedStartDate = null;
        this.dateOpenedEndDate = null;
        this.updatedOnStartDate = null;
        this.updatedOnEndDate = null;
        this.lastActionStartDate = null;
        this.lastActionEndDate = null;
        this.lastActionStartDateAsString = "";
        this.lastActionEndDateAsString = "";
        this.description = "";
        this.whyItMatters = "";
        this.mostRecentAction = "";
        this.upcomingEvents = "";
    }
}
export default class EntryAdvanceSearch extends EntryAdvanceSearchModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
